import type { SliceType } from './types';
import type { SliceUnion } from './union';

type GetSliceByType<S, T> = S extends { slice_type: T } ? S : never;

/**
 * Get slice by slice type
 *
 * @param sliceType - The type of slice to get
 */
export function isSliceOfType<T extends SliceType>(sliceType: T) {
  return (slice: SliceUnion): slice is GetSliceByType<SliceUnion, T> => {
    return slice.slice_type === sliceType;
  };
}
